import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import closeMenuIcon from "../../assets/classroom/images/classroom_bg-close-menu.png";
import ExportChat from "./exportChat";
import { login } from "../../auth/auth";
import toast, { Toaster } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const passphrase = process.env.REACT_APP_CLASSROOM_KEY;

const MenuClassroom = ({ closeMenu, messages, userName }) => {
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [submenuType, setSubmenuType] = useState(null);
  const [menuTitle, setMenuTitle] = useState("Menu");
  const [languageText, setLanguageText] = useState("Switch to Bahasa");
  const [showExportChat, setShowExportChat] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [avatars, setAvatars] = useState([]);
  const [avatarConfig, setAvatarConfig] = useState([]);
  const [topics, setTopics] = useState([]);
  const navigate = useNavigate();
  const [AvatarName, setAvatarName] = useState(
    sessionStorage.getItem("AvatarName") || ""
  );

  const translations = {
    EN: {
      exportTranscript: "Export Transcript",
      changeAvatar: "Change Avatar",
      switchTopic: "Switch Topic",
      switchLanguage: "Switch to Bahasa",
      playGame: "Play a Game",
      confirm: "Do you want to change?",
    },
    ID: {
      exportTranscript: "Ekspor Transkrip",
      changeAvatar: "Ubah Avatar",
      switchTopic: "Ubah Topik",
      switchLanguage: "Beralih ke Bahasa Inggris",
      playGame: "Mainkan Permainan",
      confirm: "Apakah Anda ingin mengubah?",
    },
  };

  useEffect(() => {
    const performLogin = async () => {
      try {
        const token = await login();
        setAuthToken(token);
      } catch (error) {
        console.error("Failed to login:", error);
      }
    };

    performLogin();
  }, []);

  useEffect(() => {
    const savedLanguage = sessionStorage.getItem("language");
    if (savedLanguage === "ID") {
      setLanguageText(translations.ID.switchLanguage);
    } else {
      setLanguageText(translations.EN.switchLanguage);
    }
  }, []);

  useEffect(() => {
    const fetchAvatars = async () => {
      if (!authToken) return;

      try {
        const { data } = await axios.get(
          `${BASE_URL}/api/avatar/passphrase/${passphrase}`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        setAvatars(data.data || []);
      } catch {
        // Handle error silently or add an optional error state
      }
    };

    fetchAvatars();
  }, [authToken, passphrase]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (!authToken) return;

      try {
        const { data } = await axios.get(
          `${BASE_URL}/api/config/passphrase/${passphrase}`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        setTopics(data.data?.[0]?.key?.name ? [data.data[0].key.name] : []);
      } catch {
        // error handling
      }
    };

    fetchTopics();
  }, [authToken, passphrase]);

  const fetchAvatarConfig = async () => {
    if (!authToken) return;

    try {
      const response = await axios.get(
        `${BASE_URL}/api/config/passphrase/${passphrase}`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      setAvatarConfig(response.data.data || []);
    } catch (error) {
      console.error("Failed to fetch avatar config ID:", error);
    }
  };

  useEffect(() => {
    fetchAvatarConfig();
  }, [authToken, passphrase]);

  const handleAvatarSelect = (avatar) => {
    const getId = avatar.id;
    console.log("Avatar ID:", getId);

    const avatarlanguage =
      sessionStorage.getItem("language") === "EN" ? "English" : "Indonesia";

    const matchingConfig = avatarConfig.find(
      (item) => item.language === avatarlanguage && item.avatar.id === getId
    );

    if (matchingConfig) {
      const configId = matchingConfig.id;
      console.log("Matching Config ID:", configId);
      sessionStorage.setItem("id", configId);
      sessionStorage.setItem("AvatarName", avatar.name);
      navigate(`/classroom/${encodeURIComponent(avatar.name)}`);
      window.location.reload();
    } else {
      console.error(
        "No matching config found for the selected avatar and language."
      );
    }
  };

  const handleChangeAvatarClick = () => {
    setShowSubmenu(true);
    setSubmenuType("avatar");
    setMenuTitle(translations[sessionStorage.getItem("language") || "EN"].changeAvatar);
  };

  const handleChangeTopicClick = () => {
    setShowSubmenu(true);
    setSubmenuType("topic");
    setMenuTitle(translations[sessionStorage.getItem("language") || "EN"].switchTopic);
  };

  const handleLanguageSwitchClick = () => {
    const currentLangCode = sessionStorage.getItem("language") || "EN";
    const currentLanguage = currentLangCode === "ID" ? "Indonesia" : "English";
    const confirmationMessage =
      translations[currentLangCode]?.confirm ||
      "Are you sure you want to switch language?";

    toast(
      (t) => (
        <div>
          <p>{confirmationMessage}</p>
          <div
            style={{
              background: "white",
              color: "#111",
              padding: "20px 0 0 0",
              borderRadius: "12px",
              width: "320px",
              fontSize: "14px",
              gap: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={() => {
                toast.dismiss(t.id);

                setLanguageText((prevText) => {
                  const newText =
                    prevText === translations.EN.switchLanguage
                      ? translations.ID.switchLanguage
                      : translations.EN.switchLanguage;

                  const newLangCode =
                    newText === translations.EN.switchLanguage ? "EN" : "ID";
                  sessionStorage.setItem("language", newLangCode);

                  let avatarlanguage =
                    newLangCode === "EN" ? "English" : "Indonesia";

                  if (avatarConfig.length > 0) {
                    const matchingConfig = avatarConfig.find(
                      (item) =>
                        item.language === avatarlanguage &&
                        item.name === AvatarName
                    );

                    if (matchingConfig) {
                      const configId = matchingConfig.id;
                      sessionStorage.setItem("id", configId);
                      sessionStorage.setItem("AvatarName", AvatarName);
                      navigate(`/classroom/${encodeURIComponent(AvatarName)}`);
                      console.log("Avatar config ID:", configId);
                    } else {
                      console.error(
                        "No matching config found for the selected avatar and language."
                      );
                    }
                  }

                  return newText;
                });
              }}
              style={{
                padding: "6px 18px",
                backgroundColor: "#0063e5",
                color: "white",
                border: "1px solid #0063e5",
                borderRadius: "999px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              {currentLanguage === "Indonesia" ? "Ya" : "Yes"}
            </button>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                padding: "6px 18px",
                backgroundColor: "#f0f0f0",
                color: "#111",
                border: "1px solid #ccc",
                borderRadius: "999px",
                cursor: "pointer",
              }}
            >
              {currentLanguage === "Indonesia" ? "Tidak" : "No"}
            </button>
          </div>
        </div>
      ),
      {
        duration: 999999,
        id: "handle-language-switch",
        position: "top-center",
      }
    );
  };

  const handleExportClick = () => {
    setShowExportChat(true);
    setShowSubmenu(false);
  };

  const SubmenuAvatar = () => (
    <div className={`submenu__avatar ${avatars.length > 1 ? "avatars" : ""}`}>
      {avatars.map((avatar, index) => (
        <div
          className="submenu__item-avatar"
          key={index}
          onClick={() => handleAvatarSelect(avatar)}
        >
          <div className="avatar-container">
            <img src={`${BASE_URL}${avatar.hyperlink}`} alt={avatar.name} />
          </div>
          <div className="avatar-name">
            <p>{avatar.name}</p>
          </div>
        </div>
      ))}
    </div>
  );

  const SubmenuTopic = () => (
    <div className="submenu__topic">
      {topics.map((topic, index) => (
        <div className="submenu__item-topic" key={index}>
          <p>{topic}</p>
        </div>
      ))}
    </div>
  );

  console.log("Language text:", languageText);

  return (
    <div className="menu__classroom">
      <Toaster containerStyle={{ zIndex: 999999999 }} />
      {!showExportChat ? (
        <>
          <div className="menu__navbar">
            <h1 className="menu__title">{menuTitle}</h1>
            <div className="close-menu" onClick={closeMenu}>
              <img src={closeMenuIcon} alt="Close Menu" />
            </div>
          </div>

          <div className="menu__content">
            {!showSubmenu ? (
              <>
                <div className="menu__item" onClick={handleExportClick}>
                  <p>
                    {
                      translations[sessionStorage.getItem("language") || "EN"]
                        .exportTranscript
                    }
                  </p>
                </div>
                <div className="menu__item" onClick={handleChangeAvatarClick}>
                  <p>
                    {
                      translations[sessionStorage.getItem("language") || "EN"]
                        .changeAvatar
                    }
                  </p>
                </div>
                <div
                  className="menu__item menu__disable"
                  // onClick={handleChangeTopicClick}
                >
                  <p>
                    {
                      translations[sessionStorage.getItem("language") || "EN"]
                        .switchTopic
                    }
                  </p>
                </div>
                <div className="menu__item" onClick={handleLanguageSwitchClick}>
                  <p>{languageText}</p>
                </div>
                <div className="menu__item menu__disable">
                  <p>
                    {
                      translations[sessionStorage.getItem("language") || "EN"]
                        .playGame
                    }
                  </p>
                </div>
              </>
            ) : submenuType === "avatar" ? (
              <SubmenuAvatar />
            ) : (
              <SubmenuTopic />
            )}
          </div>
        </>
      ) : (
        <ExportChat
          messages={messages}
          userName={userName}
          handleShowMenu={closeMenu}
        />
      )}
    </div>
  );
};

export default MenuClassroom;
